export default __webpack_public_path__ + "static/media/Otamendi.697839a2.png";